module.exports = __webpack_public_path__ + "static/media/RationalDisplay-Medium.4b493d47.svg";